import React, { useEffect, useState } from "react";
import { message, Modal, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useReportBillModel } from "../reportBillModel";
import { IReportBillDetail } from "../reportBillType";
import YhTag from "@/components/YhTag";
import { useDictModel } from "@/views/base/dict/dictModel";
import { momentFormat, formatNum, repairFormatNum } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { ColumnWidthOutlined } from "@ant-design/icons";
import useGlobalModel from "@/model/globalModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { reportBillService } from "../reportBillService";
type statusType = {
    "repair_report.reject": string, //审核驳回
    "repair_report.audited": string,//审核通过
    "repair_report.ing": string,//审核中
    "repair_report.init": string,//待审核
    "repair_report.check": string,//已验收
    [key: string]: any
}

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, checkAcceptVisible, setCheckAcceptVisible,
        loadData, setSelectedRowKeys, reset, setDispatchVisible, logVisible, setLogVisible,
        reportVisible, setReportVisible
    } = useReportBillModel();
    const { shopAndOrg: { shopId }, user: { roles, userName } } = useGlobalModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const [loading, setLoading] = useState(false);
    const onLook = (code: string) => {
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            {
                id: code, mode: "look", parentInfo: { selectedNavId }
            },
            true
        );
    }
    useEffect(() => {
        loadData()
    }, [])
    const statusColor: statusType = {
        "repair_report.reject": 'red', //审核驳回
        "repair_report.audited": 'green',//审核通过
        "repair_report.ing": 'orange',//审核中
        "repair_report.init": 'blue',//待审核，
        "repair_report.check": 'purple'//已验收
    }
    const toCheak = async (id: string) => {
        // 显示确认模态框
        Modal.confirm({
            title: "验收",
            content: `确定要验收此报修单吗？`,
            okText: "确认",
            okType: "primary",
            cancelText: "取消",
            onOk: async () => {
                setLoading(true);
                try {
                    // 模拟发布接口调用
                    const res = await reportBillService.toCheak(id);
                    if (res) {
                        message.success("验收成功");
                        loadData();
                    }
                } catch (error: any) {
                } finally {
                    setLoading(false);
                }
            },
        });
    };
    const columns: ColumnsType<IReportBillDetail> = [
        {
            title: '操作',
            width: 240,
            fixed: 'left',
            align: 'center',
            render: (t, r) => (
                <>
                    <YhAuth resCode={ResourceAuthEnum.VRM2_REPORTREPAIRS_DETIAL}>
                        <button
                            style={{
                                backgroundColor: '#4165e317',
                                color: '#4165E3',
                                border: '1px solid #4165E3',
                                borderRadius: '2px',
                                padding: '0 4px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                transition: 'all 0.2s',
                                outline: 'none'
                            }}
                            onClick={() => {
                                setSelectedRowKeys([r.id])
                                setDispatchVisible(true)
                            }}
                        >
                            详情
                        </button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.VRM2_REPORTREPAIRS_DETIALLOG}>
                        <button
                            style={{
                                backgroundColor: "#00be8712",
                                color: "#00BE87",
                                border: "1px solid #00BE87",
                                borderRadius: "2px",
                                padding: "0 4px",
                                fontSize: '12px',
                                marginLeft: '5px',
                                cursor: "pointer",
                                transition: "all 0.2s",
                                outline: "none",
                            }}
                            onClick={() => {
                                setSelectedRowKeys([r.id])
                                setLogVisible(true)
                            }}
                        >
                            审批进度
                        </button>
                    </YhAuth>
                    <button
                        style={{
                            backgroundColor: "#4bd6d717",
                            color: "#4bd6d7",
                            border: "1px solid #4bd6d7",
                            borderRadius: "2px",
                            padding: "0 4px",
                            fontSize: '12px',
                            marginLeft: '5px',
                            cursor: "pointer",
                            transition: "all 0.2s",
                            outline: "none",
                        }}
                        onClick={() => {
                            setSelectedRowKeys([r.id])
                            setReportVisible(true)
                        }}
                    >
                        工单追踪
                    </button>
                    {((r.status === 'repair_report.init' || r.status === 'repair_report.ing') && roleType(r.auditRole)) &&
                        <button
                            style={{
                                backgroundColor: '#ff980017',
                                color: '#ff9800',
                                border: '1px solid #ff9800',
                                borderRadius: '2px',
                                fontSize: '12px',
                                padding: '0 4px',
                                marginLeft: '5px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                outline: 'none'
                            }}
                            onClick={() => {
                                setSelectedRowKeys([r.id])
                                setCheckAcceptVisible(true)
                            }}
                        >
                            审核
                        </button>}
                    {r.status === 'repair_report.audited' && findStatusName(r) == '已完工' && r.createUser == userName &&
                        <button
                            style={{
                                backgroundColor: "#FF525212",
                                color: "#FF5252",
                                border: "1px solid #FF5252",
                                borderRadius: "2px",
                                padding: "0 4px",
                                fontSize: '12px',
                                marginLeft: '5px',
                                cursor: "pointer",
                                transition: "all 0.2s",
                                outline: "none",
                            }}
                            onClick={() => {
                                toCheak(r.id)
                            }}
                        >
                            验收
                        </button>}
                </>
            ),
        },
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1
        }, {
            title: '报修单号',
            width: 150,
            dataIndex: 'code',
            render: (text: any, record: any,) => <YhTootip text={text} style={{ width: 150 }} />,
        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: "转接单号",
            width: 150,
            dataIndex: "traCode",
            render: (text: any, record: any) => <YhTootip text={text} style={{ width: 150 }} />,
        },
        // {
        //     title: '服务地点：',
        //     width: 80,
        //     dataIndex: 'serviceLocationName',
        // }, 
        {
            title: '维修方式',
            width: 80,
            dataIndex: 'repairType',
            render: (text) => <span> {text == 0 ? '内修' : '外修'}</span>
        }, {
            title: '车辆牌照',
            width: 100,
            dataIndex: 'licensePlate',
            render: (text: any, record: any,) => <YhTootip text={text} style={{ width: 100 }} />,
        }, {
            title: '故障描述',
            width: 80,
            dataIndex: 'faultDesc',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '维修附加项',
            width: 200,
            dataIndex: 'additionalItems',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '维修类型',
            width: 80,
            dataIndex: 'serviceNatureName',
        }, {
            title: '车辆里程',
            width: 120,
            dataIndex: 'mileage',

        }, {
            title: '所属站点',
            width: 250,
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }, {
            title: '所属公司',
            width: 190,
            dataIndex: 'orgName',
            render: (text: any) => <YhTootip text={text} style={{ width: 190 }} />,
        }, {
            title: '报修人',
            width: 200,
            align: 'center',
            dataIndex: 'createUser',
        }, {
            title: '报修时间',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '预计完工时间',
            width: 140,
            dataIndex: 'expectedCompletionTime',
            render: (text: any, record: any) => {
                // 格式化时间
                const formattedTime = text ? momentFormat(text) : '';
                // 判断是否需要标红
                const shouldHighlight = formattedTime && isWithin24Hours(formattedTime, record);

                return (
                    <span style={{ color: shouldHighlight ? "#EF5350" : "" }}>
                        {formattedTime}
                    </span>
                );
            }
        },
        {
            title: '验收人',
            width: 140,
            align: 'center',
            dataIndex: 'checkUser',
        }, {
            title: '验收时间',
            width: 140,
            dataIndex: 'checkTime',
            render: (text) => momentFormat(text)
        },
    ];

    const isWithin24Hours = (expectedTime: any, record: any) => {
        // 如果没有预计时间，不标红
        if (!expectedTime) return false;

        // 如果单据已完工，不标红
        const isCompleted = record.externalStatus == 'external_repair.complete' || record.maintenanceStatus == 'maintenance.completed' || record.maintenanceStatus == 'maintenance.settle';

        if (isCompleted) return false;

        // 转换为时间戳（毫秒）
        const expected = new Date(expectedTime).getTime();
        const now = new Date().getTime();
        const twentyFourHours = 24 * 60 * 60 * 1000; // 86400000毫秒

        // 时间在当前时间之后且小于24小时
        return expected > now && expected - now < twentyFourHours;
    }
    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const roleType = (val: string) => {
        return roles.includes(val)
    };
    const findStatusName = (item: any) => {
        let newName = ''
        if (item.externalStatus) {
            newName = (item.externalStatus == 'external_repair.init' || item.externalStatus == 'external_repair.send') ? '已开单' : (item.externalStatus == 'external_repair.sendend' || item.externalStatus == 'external_repair.ing') ? '待修' : item.externalStatus == 'external_repair.audited' ? '在修' : item.externalStatus == 'external_repair.reject' ? '审批驳回' : '已完工'
        }
        else if (item.maintenanceStatus) {
            newName = item.maintenanceStatus == 'maintenance.create' ? '已开单' : item.maintenanceStatus == 'maintenance.await' ? '待修' : (item.maintenanceStatus == 'maintenance.underway' || item.maintenanceStatus == 'maintenance.under-review' || item.maintenanceStatus == 'maintenance.approved' || item.maintenanceStatus == 'maintenance.completed') ? '在修' : (item.maintenanceStatus == 'maintenance-status.final' || item.maintenanceStatus == 'maintenance.settle') ? '已完工' : ''
        }
        return newName
    };
    return (
        <Table
            bordered
            loading={loading}
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IReportBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id as string),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.id as string]);
            //     }
            // })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}
